import { IkasThemeJsonPageComponent } from "./component";

export type IkasThemeJsonPage = {
  id: string;
  name: string | null;
  type: IkasThemeJsonPageType;
  slug: string | null;
  pageTitle: string | null;
  description: string | null;
  components: IkasThemeJsonPageComponent[];
  specifications: IkasThemeJsonPageSpecification[] | null;
  canonicals: string[] | null;
  disableIndex: boolean | null;
};

export type IkasThemeJsonPageSpecification = {
  id: string;
  components: IkasThemeJsonPageComponent[];
};

export enum IkasThemeJsonPageType {
  INDEX = "INDEX",
  CATEGORY = "CATEGORY",
  BRAND = "BRAND",
  PRODUCT = "PRODUCT",
  CUSTOM = "CUSTOM",
  ACCOUNT = "ACCOUNT",
  ADDRESSES = "ADDRESSES",
  ORDERS = "ORDERS",
  ORDER_DETAIL = "ORDER_DETAIL",
  LOGIN = "LOGIN",
  REGISTER = "REGISTER",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  RECOVER_PASSWORD = "RECOVER_PASSWORD",
  CART = "CART",
  FAVORITE_PRODUCTS = "FAVORITE_PRODUCTS",
  SEARCH = "SEARCH",
  NOT_FOUND = "NOT_FOUND",
  BLOG = "BLOG",
  BLOG_INDEX = "BLOG_INDEX",
  BLOG_CATEGORY = "BLOG_CATEGORY",
  CHECKOUT = "CHECKOUT",
  RAFFLE = "RAFFLE",
  RAFFLE_DETAIL = "RAFFLE_DETAIL",
  RAFFLE_ACCOUNT = "RAFFLE_ACCOUNT",
}
